<template>
  <footer class="page-footer">
    <div class="footer-content">
      <template v-if="$store.state.userinfo.isAdmin">
        <div class="online-count">
          <span class="online-dot"></span>
          <span>在线人数: {{ $store.state.onlineCount }}人</span>
        </div>
        <span class="divider">|</span>
        <div class="daily-visitor-count">
          <span class="visitor-icon">👥</span>
          <span>24小时访问: {{ $store.state.dailyVisitorCount }}人</span>
        </div>
        <span class="divider">|</span>
      </template>
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="beian-link">
        {{ beianNumber }}
      </a>
      <span class="divider">|</span>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank" rel="noopener noreferrer"
         class="gongan-link">
        <img src="https://img.lkval.com/static/assets/gonganbeian.png" alt="公安备案" class="gongan-icon"/>
        <span>{{ gonganBeianNumber }}</span>
      </a>
      <span class="divider">|</span>
      <span class="sponsor-link" @click="openSponsorDialog">
        ⭐赞助支持
      </span>
    </div>

    <!-- 赞助支持对话框 -->
    <div v-if="showSponsorDialog" class="sponsor-dialog-overlay" @click="closeSponsorDialog">
      <div class="sponsor-dialog" @click.stop>
        <div class="sponsor-dialog-header">
          <h3>赞助支持</h3>
          <span class="close-btn" @click="closeSponsorDialog">&times;</span>
        </div>
        <div class="sponsor-dialog-content">
          <div class="sponsor-qr-code">
            <img src="https://img.lkval.com/static/assets/zanzhu_v2.jpg" alt="赞助二维码" class="qr-code-img"/>
            <p class="sponsor-title">微信赞赏</p>
            <p class="sponsor-description">也可以通过B站或者QQ群联系我进行赞助，感谢您的支持！</p>
          </div>
          <div class="sponsor-list">
            <div class="sponsor-list-content">
              <div class="sponsor-item" v-for="(sponsor, index) in sponsors.slice().reverse()" :key="index">
                <div class="sponsor-header">
                  <div class="sponsor-name">{{ sponsor.name }}</div>
                  <div class="sponsor-amount">¥{{ sponsor.amount }}</div>
                </div>
                <div class="sponsor-message">{{ sponsor.message }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'PageFooter',
  data() {
    return {
      beianNumber: '晋ICP备2026000928号-1',
      gonganBeianNumber: '晋公网安备14050002001939号',
      showSponsorDialog: false,
      sponsors: [
        {name: '匿名用户', amount: 5, message: '好起来了'},
        {name: '王一丹 Ekar', amount: 10, message: '还没用过 先赞助 想法做法超棒'},
        {name: '匿名用户', amount: 1, message: ''},
        {name: '晨', amount: 1, message: ''},
        {name: '匿名用户', amount: 50, message: '加油'},
        {name: 'Makoto', amount: 20, message: '网站很实用 加油'},
        {name: 'wR', amount: 1, message: ''},
        {name: 'Poggi🎈', amount: 100, message: '加油哦'},
        {name: '匿名用户', amount: 1, message: ''},
        {name: 'J', amount: 1, message: '有帮助，继续做下去，希望有app'},
        {name: '匿名用户', amount: 20, message: ''},
        {name: 'Raln', amount: 5, message: '感谢你'},
        {name: '匿名用户', amount: 6.6, message: ''},
        {name: '匿名用户', amount: 10, message: ''},
        {name: '少德', amount: 10, message: '网站做的很好，对新手帮助也很大'},
        {name: '949💤', amount: 1, message: '加油'},
        {name: '希区柯克', amount: 20, message: '加油！越做越好！'},
        {name: '阿左', amount: 10, message: '感谢您做的网站！学生没什么钱'},
        {name: '554.', amount: 5, message: ''},
        {name: 'bourbon', amount: 10, message: '加油longke Sideny直播总看你的网站'},
        {name: '.', amount: 10, message: '支持一下！'},
        {name: '匿名用户', amount: 1, message: '新年快乐'},
        {name: '风愈静', amount: 5, message: '很棒，加油OVO🌸🌸🌸'},
      ]
    }
  },
  methods: {
    openSponsorDialog() {
      this.showSponsorDialog = true
    },
    closeSponsorDialog() {
      this.showSponsorDialog = false
    }
  }
}
</script>

<style scoped>
.page-footer {
  background-color: #f8f9fa;
  color: #666;
  padding: 0 0;
  text-align: center;
  border-top: 1px solid #eee;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.footer-content {
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.divider {
  color: #ccc;
}

.online-count {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #666;
  font-size: 14px;
}

.online-dot {
  width: 8px;
  height: 8px;
  background-color: #67c23a;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.daily-visitor-count {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #666;
  font-size: 14px;
}

.visitor-icon {
  font-size: 12px;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.footer-content a {
  color: #666;
  text-decoration: none;
}

.footer-content a:hover {
  color: #333;
  text-decoration: underline;
}

.beian-link,
.gongan-link {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #666;
  text-decoration: none;
}

.beian-link:hover,
.gongan-link:hover {
  color: #333;
  text-decoration: underline;
}

.gongan-icon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  display: block;
}

.sponsor-link {
  color: #666;
  cursor: pointer;
  font-size: 14px;
}

.sponsor-link:hover {
  color: #333;
  text-decoration: underline;
}

/* 仅在屏幕宽度小于等于 768px 时隐藏 */
.sponsor-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.sponsor-dialog {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.sponsor-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.sponsor-dialog-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.close-btn {
  font-size: 24px;
  color: #999;
  cursor: pointer;
  line-height: 1;
}

.close-btn:hover {
  color: #333;
}

.sponsor-dialog-content {
  display: flex;
  padding: 20px;
  gap: 30px;
  max-height: 60vh;
}

.sponsor-qr-code {
  flex: 0 0 260px;
  text-align: center;
}

.qr-code-img {
  width: 240px;
  height: 240px;
  object-fit: cover;
  border: 1px solid #eee;
  border-radius: 8px;
}

.sponsor-title {
  margin-top: 16px;
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin-bottom: 8px;
}

.sponsor-description {
  font-size: 14px;
  color: #666;
  line-height: 1.4;
  padding: 0 10px;
  text-align: center;
}

.sponsor-list {
  flex: 1;
  min-width: 0;
}

.sponsor-list h4 {
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.sponsor-list-content {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 12px;
}

.sponsor-item {
  padding: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.sponsor-item:last-child {
  border-bottom: none;
}

.sponsor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.sponsor-name {
  font-weight: 600;
  color: #333;
}

.sponsor-amount {
  color: #f56c6c;
  font-weight: 600;
}

.sponsor-message {
  font-size: 14px;
  color: #666;
  line-height: 1.4;
  text-align: left;
}

/* 滚动条样式 */
.sponsor-list-content::-webkit-scrollbar {
  width: 6px;
}

.sponsor-list-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.sponsor-list-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.sponsor-list-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 响应式布局 */
@media screen and (max-width: 768px) {
  .page-footer {
    display: none;
  }

  .sponsor-dialog-content {
    flex-direction: column;
    align-items: center;
  }

  .sponsor-qr-code {
    flex: none;
  }

  .sponsor-list {
    width: 100%;
  }
}
</style>
